import { toast } from "react-toastify";
import { MMPRHAPIBaseService, ehrAPIBaseService } from "./http-common";
import i18n from "multilingual";

const getError = (error) => {
    let errorDisplay = i18n.t('toast.SOMETHING_WENT_WRONG_PLEASE_TRY_AGIAN_LATER');
    if (Array.isArray(error?.response?.data?.errors)) {
        errorDisplay = '';
        error?.response?.data?.errors.forEach(err => {
            errorDisplay += err?.message + '\n';
        });
    }
    return errorDisplay || i18n.t('toast.SOMETHING_WENT_WRONG_PLEASE_TRY_AGIAN_LATER')
}


export const GET_DEPARTMENTS_AND_CREDENTIALS = async () => {
    try {
        const response = await MMPRHAPIBaseService.get('config');
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}

export const GET_DEPARTMENTS_AND_CREDENTIALS_AT_LOGIN = async (token) => {
    try {
        const response = await ehrAPIBaseService.get(`/mmprh/v1/${token}/config`);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }

}


export const GET_CREDENTIALS = async() => {

    try {
        const response = await MMPRHAPIBaseService.get(`credentials`);
       
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }

}

export const GET_USER_CREDENTIAL = async (persionId) => {
    try {
        const response = await MMPRHAPIBaseService.get(`user-credential?userId=${persionId}`);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}

export const CREATE_CREDENTIAL = async (payload) => {
    try {
        const response = await MMPRHAPIBaseService.post('credential', payload);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}

export const UPLOAD_USER_CREDENTIAL = async (id, payload) => {
    try {
        const response = await MMPRHAPIBaseService.post(`user-credential/${id}/submit`, payload);
        return response
    } catch (error) {
        toast.error(getError(error))
    }
}

export const EDIT_CREDENTIAL = async (payload, id) => {
    try {
        const response = await MMPRHAPIBaseService.put(`credential/${id}`, payload);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}
export const DELETE_CREDENTIAL = async (id) => {
    try {
        const response = await MMPRHAPIBaseService.delete(`credential/${id}`);
        return response
    } catch (error) {
        if(error?.response?.data?.code === "constraint-violation" && error?.response?.data?.error?.toLowerCase().includes("foreign key violation")) {
            toast.error(i18n.t('common.SELECTED_CREDENTIAL_IS_ASSOCIATED_WITH_ROLE_CREDENTIALS_PLEASE_REMOVE_THE_ROLE_CREDENTIALS_FIRST'));
        } else {
            toast.error(getError(error));
        }
    }
}

export const CREATE_DEPARTMENT = async (payload) => {
    try {
        const response = await MMPRHAPIBaseService.post('department', payload);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}

export const UPDATE_DEPARTMENT = async ({ payload, deptId }) => {
    try {
        const response = await MMPRHAPIBaseService.put(`department/${deptId}`, payload);
        return response.data
    } catch (error) {
        toast.error(getError(error))
    }
}

export const DELETE_DEPARTMENT = async ({ deptId }) => {
    try {
        const response = await MMPRHAPIBaseService.delete(`department/${deptId}`);
        return response.data
    } catch (error) {
        if(error?.response?.data?.code === "constraint-violation" && error?.response?.data?.error?.toLowerCase().includes("foreign key violation")) {
            toast.error(i18n.t('common.SELECTED_DEPARTMENT_IS_ASSOCIATED_WITH_ROLES_PLEASE_REMOVE_THE_ROLES_FIRST'));
        } else {
            toast.error(getError(error));
        }
    }
}

export const CREATE_ROLE = async (payload) => {
    try {
        const response = await MMPRHAPIBaseService.post('role-api/role-with-credentials', payload);
        return response.data
    } catch (error) {
        if(error?.response?.data?.code === "constraint-violation" && error?.response?.data?.error?.toLowerCase().includes("uniqueness violation")) {
            toast.error(i18n.t('common.ROLE_ALREADY_EXISTS'));
        } else {
            toast.error(getError(error));
        }
    }
}

export const UPDATE_ROLE = async ({ roleId, payload }) => {
    try {
        const response = await MMPRHAPIBaseService.put(`role-api/role-with-credentials/${roleId}`, payload);
        return response.data
    } catch (error) {
        if(error?.response?.data?.code === "constraint-violation" && error?.response?.data?.error?.toLowerCase().includes("uniqueness violation")) {
            toast.error(i18n.t('common.ROLE_ALREADY_EXISTS'));
        } else {
            toast.error(getError(error));
        }
    }
}

export const DELETE_ROLE = async ({ roleId }) => {
    try {
        const response = await MMPRHAPIBaseService.delete(`role/${roleId}`);
        return response.data
    } catch (error) {
        if(error?.response?.data?.code === "constraint-violation" && error?.response?.data?.error?.toLowerCase().includes("foreign key violation")) {
            toast.error(i18n.t('common.SELECTED_ROLE_IS_ASSOCIATED_WITH_ROLE_CREDENTIALS_PLEASE_REMOVE_THE_ROLE_CREDENTIALS_FIRST'));
        } else {
            toast.error(getError(error));
        }
    }
}